import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Session} from './Session';
import {Config} from './Config';
import {ISpecialty} from '../interfaces/ISpecialty';

@Injectable()
export class Specialties {
  private config:Config;
  private session:Session;
  private http: HttpClient;
  private list:Array<ISpecialty> = [];
  private loadingPromise;

  constructor(config:Config, http: HttpClient, session:Session) {
    this.config = config;
    this.http = http;
    this.session = session;
  }

  load() {
    if (this.list && this.list.length > 0) {
      return new Promise((resolve)=> {
        resolve(this.list);
      });
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = new Promise((resolve, reject)=> {
      let headers = new HttpHeaders();
      headers = this.session.setAuthHeader(headers);
      this.http.get(this.config.apiUrl+'/specialty', {headers: headers})

        .subscribe((objects)=> {
          this.loadingPromise = null;
          if (objects instanceof Array) {
            this.list = objects;
            resolve(this.list);
          } else {
            reject();
          }
        }, ()=> {
          this.loadingPromise = null;
          reject();
        });
    });
    return this.loadingPromise;
  }

  loadToMap(map:{[id:number]:ISpecialty;}, callback?) {
    this.load().then((specialties)=> {
      if (specialties && specialties.length > 0) {
        specialties.forEach((s)=> {
          map[s.id] = s;
        });
        if (callback) {callback();}
      }
    }, ()=> {});
  }

  loadToList(list:ISpecialty[]) {
    this.load().then((specialties)=> {
      if (specialties && specialties.length > 0) {
        specialties.forEach((s)=> {
          list.push(s);
        });
      }
    }, ()=> {});
  }
}
